<template>
  <!-- Its results follow the typing: Enter would submit the form and reload the app. -->
  <form class="base-search-bar" @submit.prevent>
    <input
      class="base-search-bar__input"
      :class="{
        'has-gray-background': hasGrayBackground,
      }"
      :name="name"
      :id="name"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      enterkeyhint="search"
      @input="input"
      @change="input"
      @blur="input"
      @keydown.enter="closeKeyboardOnTouch($event.target)"
      v-on="listeners"
      v-bind="attrs"
    />

    <BaseIcon name="search" class="base-search-bar__icon" />
  </form>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon.vue';
import { closeKeyboardOnTouch } from '@/util/search-key';

export default {
  name: 'BaseSearchBar',
  components: {
    BaseIcon,
  },
  props: {
    name: String,
    value: {
      type: null,
      default: null,
    },
    type: {
      type: String,
      default: 'text',
    },
    // TODO
    placeholder: {
      type: String,
      default: 'Search',
    },
    hasGrayBackground: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    listeners() {
      const { input, ...listeners } = this.$listeners;
      return listeners;
    },
    attrs() {
      const { rows, ...attrs } = this.$attrs;
      return attrs;
    },
  },
  methods: {
    closeKeyboardOnTouch,
    input(event) {
      this.$emit('input', event.target.value);
    },
  },
};
</script>

<style lang="scss">
.base-search-bar {
  position: relative;
  width: 100%;

  &__input {
    background: $color-white;
    border-radius: $border-radius-large;
    border: 1px solid transparent;
    padding-left: 48px;
    outline: none;
    transition: border 200ms ease;
    width: 100%;
    height: 44px;
    align-items: center;

    &:hover,
    &:active {
      border: 1px solid $color-normal-pale;
    }
    &:focus {
      border: 1px solid $color-accent;
    }

    &.has-gray-background {
      background: $color-neutral-pale;
    }
  }

  &__icon {
    align-items: center;
    background: transparent;
    border: none;
    color: $color-normal;
    cursor: pointer;
    display: flex;
    justify-content: center;
    left: 12px;
    outline: none;
    padding: 0;
    position: absolute;
    top: 9px;
    transition: color 200ms ease;
    height: 24px;
    width: 24px;

    &:hover,
    &:active {
      color: $color-accent;
    }

    &:focus {
      box-shadow: $shadow-focus-outline;
    }
  }
}
</style>
